import { Component, Input, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { EditHistory } from '../models/editHistory';
import { BreakpointService } from '../breakpoint.service';

@Component({
  selector: 'app-edit-history-display',
  templateUrl: './edit-history-display.component.html',
  styleUrls: ['./edit-history-display.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditHistoryDisplayComponent {
  @Input() edits: EditHistory[];
  @Input() columns: string[];
  @Input() isAdmin: boolean;

  private _subscription;
  isHandset: boolean = false;
  constructor(
    private breakpointSvc: BreakpointService) {}

  ngOnInit() {
    this._subscription = this.breakpointSvc.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
      }
    )
  }

}
